module.exports = __webpack_public_path__ + "static/gallery21-08adc2dea2cee4d896e3914b3fa1b901.jpg";